import React from "react";
import Chip from "@material-ui/core/Chip";

export class Details extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      candidateDetails: this.props.candidateDetails,
    };
  }

  render() {
    const { candidateDetails } = this.props;
    console.log("candidateDetails: ", candidateDetails);
    return (
      <div style={{ width: 350 }}>
        <p className="input-label">Name of candidate </p>
        <div className="rounded-rectangle-div">
          <p className="small-dark-secondary">
            {candidateDetails &&
              candidateDetails[0] &&
              candidateDetails[0].name}
          </p>
        </div>
        <p className="input-label margin-top-16">Email</p>
        <div className="rounded-rectangle-div">
          <p className="small-dark-secondary">
            {candidateDetails &&
              candidateDetails[0] &&
              candidateDetails[0].emailid}
          </p>
        </div>
        <p className="input-label margin-top-16">Phone</p>
        <div className="rounded-rectangle-div">
          <p className="small-dark-secondary">
            {candidateDetails &&
              candidateDetails[0] &&
              candidateDetails[0].mobilenumber}
          </p>
        </div>
        <p className="input-label margin-top-16">Job</p>
        <div className="rounded-rectangle-div">
          <p className="small-dark-secondary">
            {this.props.candidateDesignation}
          </p>
        </div>
        {/* <p className="input-label margin-top-16">Past compensation</p>
        <div className="rounded-rectangle-div">
          <p className="small-dark-secondary">
            {candidateDetails &&
              candidateDetails[0] &&
              candidateDetails[0].emailid}
          </p>
        </div> */}
        <p className="input-label margin-top-16">Notice period</p>
        <div className="rounded-rectangle-div">
          <p className="small-dark-secondary">
            {candidateDetails &&
              candidateDetails[0] &&
              candidateDetails[0].noticeperiod}
          </p>
        </div>
        {candidateDetails &&
          candidateDetails[0] &&
          candidateDetails[0].sourcetypename && (
            <div>
              <p className="input-label margin-top-16">Source</p>
              <Chip
                size="Angellist"
                label={
                  candidateDetails &&
                  candidateDetails[0] &&
                  candidateDetails[0].sourcetypename
                }
                style={{
                  background: "#fff",
                  color: "#1a6a48",
                  border: "1px solid #1a6a48",
                }}
              />
            </div>
          )}
        {/* <p className="input-label margin-top-16">Tags</p>
        <Chip
          size="Reapplied"
          label="Reapplied"
          style={{
            background: "#fff",
            color: "#ad0e46",
            border: "1px solid #ad0e46",
            marginRight: 8,
          }}
        /> */}
      </div>
    );
  }
}

export default Details;
